import { getDefaultExportFromCjs } from './_commonjsHelpers.js';
import { __require as requireBrowser } from '../node_modules/invariant/browser.js';

var browserExports = requireBrowser();
var invariant = /*@__PURE__*/getDefaultExportFromCjs(browserExports);

export { invariant as default };
